// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root___WtPo","header":"ReportDetails_header__1Y2P7","title":"ReportDetails_title__2LPx3","left":"ReportDetails_left__3VYNP"};